<style>
@import '../../assets/css/account.css';
</style>

<template>
    <div class="main-panel">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                    <form @submit.prevent="initialize" :submit="initialize">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('transaction_transfer.table_from_user')}}</template>
                            <el-input v-model="ajaxSearch.from_master_id" clearable></el-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('transaction_transfer.table_to_user')}}</template>
                            <el-input v-model="ajaxSearch.to_master_id" clearable></el-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('transaction_transfer.table_code')}}</template>
                            <el-input v-model="ajaxSearch.code" clearable></el-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_date')}}</template>
                            <b-form-input v-model="ajaxSearch.created_at" type="date" clearable></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label"></template>
                            <b-button variant="primary" type="submit">{{$t('button.search')}}</b-button>
                        </b-form-group>
                    </form>
                </b-card>
                <b-card :header="$t($route.name)">
                    <b-button variant="primary" class="mb-3 ml-1 float-right" @click="getDeduct()" v-if="permissionList.includes(permission.deduct)"><font-awesome-icon icon="plus"/> {{$t('transaction_transfer.table_deduct')}}</b-button>
                    <b-button variant="primary" class="mb-3 ml-1 float-right" @click="getTopup()" v-if="permissionList.includes(permission.topup)"><font-awesome-icon icon="plus"/> {{$t('transaction_transfer.table_topup')}}</b-button>
                    <b-button variant="primary" class="mb-3 ml-1 float-right" @click="getDeductGCA()" v-if="permissionList.includes(permission.deductGCA)"><font-awesome-icon icon="plus"/> {{$t('transaction_transfer.table_deduct_gca')}}</b-button>
                    <b-button variant="primary" class="mb-3 float-right" @click="getTopupGCA()" v-if="permissionList.includes(permission.topupGCA)"><font-awesome-icon icon="plus"/> {{$t('transaction_transfer.table_topup_gca')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>

                <b-modal id="getTopup" :title="$t('transaction_transfer.table_topup')" size="lg" @ok="topup" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="topupForm" @submit.prevent="topup">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('transaction_transfer.table_to_user')}}</template>
                            <b-input-group>
                                <b-form-input v-model="ajaxCheckUser" name="to_user"></b-form-input>
                                <b-input-group-append>
                                    <b-button variant="primary" @click="checkUser()">{{$t('button.search')}}</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                        <hr>
                        <b-form-group label-cols="12" label-cols-lg="4" v-for="(topup,index) in ajaxTopup" :key="index">
                            <template slot="label">{{topup.name}}</template>
                            <b-form-input :name="'value['+topup.code+']'" value="0"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('transaction_transfer.table_remark')}}</template>
                            <b-form-textarea name="ramark"></b-form-textarea>
                        </b-form-group>
                    </form>
                </b-modal>

                <b-modal id="getDeduct" :title="$t('transaction_transfer.table_deduct')" size="lg" @ok="deduct" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="deductForm" @submit.prevent="deduct">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('transaction_transfer.table_to_user')}}</template>
                            <b-input-group>
                                <b-form-input v-model="ajaxCheckUser" name="to_user"></b-form-input>
                                <b-input-group-append>
                                    <b-button variant="primary" @click="checkUser()">{{$t('button.search')}}</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                        <hr>
                        <b-form-group label-cols="12" label-cols-lg="4" v-for="(deduct,index) in ajaxDeduct" :key="index">
                            <template slot="label">{{deduct.name}}</template>
                            <b-form-input :name="'value['+deduct.code+']'" value="0"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('transaction_transfer.table_remark')}}</template>
                            <b-form-textarea name="ramark"></b-form-textarea>
                        </b-form-group>
                    </form>
                </b-modal>

                <b-modal id="getTopupGCA" :title="$t('transaction_transfer.table_topup_gca')" size="lg" @ok="topupGCAValidate" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="topupFormGCA" @submit.prevent="topupGCAValidate">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('transaction_transfer.table_to_user')}}</template>
                            <b-input-group>
                                <b-form-input v-model="ajaxCheckUser" name="to_user"></b-form-input>
                                <b-input-group-append>
                                    <b-button variant="primary" @click="checkUser()">{{$t('button.search')}}</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                        <hr>
                        <b-form-group label-cols="12" label-cols-lg="4" v-for="(topup,index) in ajaxTopupGCA" :key="index">
                            <template slot="label">{{topup.name}}</template>
                            <b-form-input :name="'value['+topup.code+']'" value="0"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('affiliate.table_security_password')}}</template>
                            <b-form-input name="security" type="password"></b-form-input>
                        </b-form-group>
                    </form>
                </b-modal>

                <b-modal id="getDeductGCA" :title="$t('transaction_transfer.table_deduct_gca')" size="lg" @ok="deductGCAValidate" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="deductFormGCA" @submit.prevent="deductGCAValidate">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('transaction_transfer.table_to_user')}}</template>
                            <b-input-group>
                                <b-form-input v-model="ajaxCheckUser" name="to_user"></b-form-input>
                                <b-input-group-append>
                                    <b-button variant="primary" @click="checkUser()">{{$t('button.search')}}</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                        <hr>
                        <b-form-group label-cols="12" label-cols-lg="4" v-for="(deduct,index) in ajaxDeductGCA" :key="index">
                            <template slot="label">{{deduct.name}}</template>
                            <b-form-input :name="'value['+deduct.code+']'" value="0"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('affiliate.table_security_password')}}</template>
                            <b-form-input name="security" type="password"></b-form-input>
                        </b-form-group>
                    </form>
                </b-modal>

                <b-modal id="getDeductGCAValidate" :title="$t('transaction_transfer.table_deduct_gca')"  @ok="deductGCA" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <b-form-group label-cols="4" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_to_user')}}</template>
                        <label style="margin-top: 0.5rem;">{{ajaxDeductGCAValidate.to_user}}</label>
                    </b-form-group>
                    <div v-for="(list,index) in ajaxDeductGCAValidate.deduct_list" :key="index">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_code')}}</template>
                            <label style="margin-top: 0.5rem;">{{list.code}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_amount')}}</template>
                            <label style="margin-top: 0.5rem;">{{list.amount}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_convert_amount')}}</template>
                            <label style="margin-top: 0.5rem;">{{list.converted_amount}}</label>
                        </b-form-group>
                    </div>
                    <b-form-group label-cols="4" label-cols-lg="4">
                        <template slot="label">{{$t('transaction_transfer.table_total_deduct')}}</template>
                        <label style="margin-top: 0.5rem;">{{ajaxDeductGCAValidate.total_deduct}}</label>
                    </b-form-group>
                </b-modal>

                <b-modal id="getTopupGCAValidate" :title="$t('transaction_transfer.table_topup_gca')"  @ok="topupGCA" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <b-form-group label-cols="4" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_to_user')}}</template>
                        <label style="margin-top: 0.5rem;">{{ajaxTopupGCAValidate.to_user}}</label>
                    </b-form-group>
                    <div v-for="(list,index) in ajaxTopupGCAValidate.topup_list" :key="index">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_code')}}</template>
                            <label style="margin-top: 0.5rem;">{{list.code}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_amount')}}</template>
                            <label style="margin-top: 0.5rem;">{{list.amount}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_convert_amount')}}</template>
                            <label style="margin-top: 0.5rem;">{{list.converted_amount}}</label>
                        </b-form-group>
                    </div>
                    <b-form-group label-cols="4" label-cols-lg="4">
                        <template slot="label">{{$t('transaction_transfer.table_total_topup')}}</template>
                        <label style="margin-top: 0.5rem;">{{ajaxTopupGCAValidate.total_topup}}</label>
                    </b-form-group>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {transferAjaxTable,getTransferTopup,checkUser,transferTopup,getTransferDeduct,transferDeduct,getTransferTopupGCA,transferTopupGCA,getTransferDeductGCA,transferDeductGCA,transferDeductGCAValidate,transferTopupGCAValidate} from '@/system/model/transaction';
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',created_at:'',code:'',from_master_id:'',to_master_id:'',transaction_type:'',total_amount:''},
            ajaxRow:'',
            ajaxTopup:[],
            ajaxTopupGCA:[],
            ajaxTopupGCAValidate:[],
            ajaxTopupGCAValidateData:[],
            ajaxDeduct:[],
            ajaxDeductGCA:[],
            ajaxDeductGCAValidate:[],
            ajaxDeductGCAValidateData:[],
            ajaxCheckUser:'',
            pageLimit:10,
            permission:{
                topup:'74A541',
                deduct:'63FA54',
                topupGCA:'595B60',
                deductGCA:'4D5812'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('transaction_transfer.table_id'),
                width:'114'
            },{
                prop: "created_at",
                label: this.$t('transaction_transfer.table_date'),
                width:'336'
            },{
                prop: "code",
                label: this.$t('transaction_transfer.table_code'),
                width:'224'
            },{
                prop: "from_master_id",
                label: this.$t('transaction_transfer.table_from_user'),
                width:'224'                
            },{
                prop: "to_master_id",
                label: this.$t('transaction_transfer.table_to_user'),
                width:'224'                              
            },{
                prop: "transaction_type",
                label: this.$t('transaction_transfer.table_transaction_type'),
                width:'224'                              
            },{
                prop: "total_amount",
                label: this.$t('transaction_transfer.table_amount'),
                width:'224'                             
            }]        
        }
    },methods:{
        initialize(){
            var self = this;
            var result = transferAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.created_at,this.ajaxSearch.code,this.ajaxSearch.from_master_id,this.ajaxSearch.to_master_id,this.ajaxSearch.transaction_type,this.ajaxSearch.total_amount);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },checkUser(){
            var self = this;
            var result = checkUser(this.ajaxCheckUser);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.$swal.fire({
                        type: 'success',
                        text: self.$t(value.returnMsg),
                    });
                }else{
                    var text = "";
                    if(Array.isArray(value.returnMsg)){
                        value.returnMsg.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                    }else{
                        text = self.$t(value.returnMsg);
                    }

                    self.$swal.fire({
                        type: 'error',
                        html: text,
                    });
                }
            });
        },getTopup(){
            if(this.permissionList.includes(this.permission.topup)){
                var self = this;
                var result = getTransferTopup();
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    self.$bvModal.show('getTopup');
                    if(value.valid){
                        self.ajaxTopup = value.data;
                    }
                });
            }
        },topup(){
            if(this.permissionList.includes(this.permission.topup)){
                var self = this;
                var form = document.getElementById('topupForm');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                var result = transferTopup(formData);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();                   
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();                   
                            }
                        });
                    }
                });
            }
        },getDeduct(){
            if(this.permissionList.includes(this.permission.deduct)){
                var self = this;
                var result = getTransferDeduct();
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    self.$bvModal.show('getDeduct');
                    if(value.valid){
                        self.ajaxDeduct = value.data;
                    }
                });
            }
        },deduct(){
            if(this.permissionList.includes(this.permission.deduct)){
                var self = this;
                var form = document.getElementById('deductForm');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                var result = transferDeduct(formData);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();                   
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();                   
                            }
                        });
                    }
                });
            }
        },getTopupGCA(){
            if(this.permissionList.includes(this.permission.topupGCA)){
                var self = this;
                var result = getTransferTopupGCA();
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    self.$bvModal.show('getTopupGCA');
                    if(value.valid){
                        self.ajaxTopupGCA = value.data;
                    }
                });
            }
        },topupGCAValidate(){
            if(this.permissionList.includes(this.permission.deductGCA)){
                var self = this;
                var form = document.getElementById('topupFormGCA');
                this.ajaxTopupGCAValidateData = form;
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                var result = transferTopupGCAValidate(formData);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.initialize();
                        self.ajaxTopupGCAValidate = value.data;
                        self.$bvModal.show('getTopupGCAValidate');
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();                   
                            }
                        });
                    }
                });
            }
        },topupGCA(){
            if(this.permissionList.includes(this.permission.topupGCA)){
                var self = this;
                // var form = document.getElementById('topupFormGCA');
                var formData = new FormData(this.ajaxTopupGCAValidateData);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                var result = transferTopupGCA(formData);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();                   
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();                   
                            }
                        });
                    }
                });
            }
        },getDeductGCA(){
            if(this.permissionList.includes(this.permission.deductGCA)){
                var self = this;
                var result = getTransferDeductGCA();
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    self.$bvModal.show('getDeductGCA');
                    if(value.valid){
                        self.ajaxDeductGCA = value.data;
                    }
                });
            }
        },deductGCAValidate(){
            if(this.permissionList.includes(this.permission.deductGCA)){
                var self = this;
                var form = document.getElementById('deductFormGCA');
                this.ajaxDeductGCAValidateData = form;
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                var result = transferDeductGCAValidate(formData);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.initialize();
                        self.ajaxDeductGCAValidate = value.data;
                        self.$bvModal.show('getDeductGCAValidate');
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();                   
                            }
                        });
                    }
                });
            }
        },deductGCA(){
            if(this.permissionList.includes(this.permission.deductGCA)){
                var self = this;
                var formData = new FormData(this.ajaxDeductGCAValidateData);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                var result = transferDeductGCA(formData);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();                   
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();                   
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
